export * from './info.service';
export { InfoModule } from './info.module';
export { InfoComponent } from './info.component';
